//import axios from "./lib/extention/index.js";
import supabase from "../../../supabaseClient.js";
import axios from "axios";
const EMPLOYEE_API_BASE_URL = "http://localhost:8080/api/v1/employees";
//const POSTS_API_BASE_URL = "http://localhost:8080/posts/getall";
//const POSTS_SEND_BASE_URL = "http://localhost:8080/posts/Post_save";
const POSTS_API_BASE_URL = "https://tanyapendeta.online/posts/posts/getall";
const POSTS_SEND_BASE_URL = "https://tanyapendeta.online/posts/posts/Post_save";
//const POSTS_API_BASE_URL = "https://gentle-ravine-50200.herokuapp.com/posts/getall";
//const POSTS_SEND_BASE_URL = "http://gentle-ravine-50200.herokuapp.com/posts/Post_save";

class Posts_sender_service {
  getEmployees() {
    return axios.get(EMPLOYEE_API_BASE_URL);
  }

  async getposts(PostsId) {
    const { data, error } = await supabase
      .from("posts")
      .select("*")
      .eq("post_id", PostsId)
      .limit(10);

    if (error) {
      console.error("Error fetching posts:", error);
    } else {
      console.log("Posts:", data);
      return data;
    }
  }

  sendpost(post) {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      },
    };
    return axios.post(POSTS_SEND_BASE_URL, post);
  }

  createEmployee(employee) {
    return axios.post(EMPLOYEE_API_BASE_URL, employee);
  }

  getEmployeeById(employeeId) {
    return axios.get(EMPLOYEE_API_BASE_URL + "/" + employeeId);
  }

  updateEmployee(employee, employeeId) {
    return axios.put(EMPLOYEE_API_BASE_URL + "/" + employeeId, employee);
  }

  deleteEmployee(employeeId) {
    return axios.delete(EMPLOYEE_API_BASE_URL + "/" + employeeId);
  }
}

export default new Posts_sender_service();
